/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-07-07 16:28:07
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-09-22 09:58:43
 * @FilePath: \ui\src\pages\components\FunctionMenu\const.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import type { FunctionMenuItem } from '../../../types'
import message from '@/assets/icon/AI／icon／message.svg'
import RAG from '@/assets/icon/AI／icon／RAG.svg'
import image from '@/assets/icon/AI／icon／image.svg'
export const functionMenuItems: FunctionMenuItem[] = [
  {
    key: 'chat',
    icon: (
      <img
        src={message}
        alt="新对话"
        style={{ width: '18px', height: '18px' }}
      />
    ),

    label: '新对话',
    // render: (props: any) => {
    //   const { item, styles, handleNewChat } = props
    //   return (
    //     <Button
    //       key={item?.key}
    //       onClick={handleNewChat}
    //       type="primary"
    //       className={styles.newChatBtn}
    //       icon={<PlusOutlined />}
    //       block
    //     >
    //       新对话
    //     </Button>
    //   )
    // },
  },
  {
    key: 'rag_chat',
    icon: (
      <img
        src={RAG}
        alt="变频器助手"
        style={{ width: '18px', height: '18px' }}
      />
    ),
    label: '变频器助手',
  },
  // {
  //   key: 'img_chat',
  //   icon: (
  //     <img
  //       src={image}
  //       alt="图像生成"
  //       style={{ width: '18px', height: '18px' }}
  //     />
  //   ),
  //   label: '图像生成',
  // },
  // {
  //   key: 'mcp_chat',
  //   icon: (
  //     <img
  //       src="/icon/AI／icon／intelligentagent.svg"
  //       alt="AI工具"
  //       style={{ width: '18px', height: '18px' }}
  //     />
  //   ),
  //   label: 'AI工具',
  // },
  // {
  //   key: 'long_chat',
  //   icon: (
  //     <img
  //       src="/icon/AI／icon／document.svg"
  //       alt="AI文档"
  //       style={{ width: '18px', height: '18px' }}
  //     />
  //   ),
  //   label: 'AI文档',
  // },

  // {
  //   key: 'multi-modal',
  //   icon: (
  //     <img
  //       src="/icon/AI／icon／intelligentagent.svg"
  //       alt="AI工具"
  //       style={{ width: '18px', height: '18px' }}
  //     />
  //   ),
  //   label: '多模态',
  // },
  // {
  //   key: 'tool-calling',
  //   icon: (
  //     <img
  //       src="/icon/AI／icon／intelligentagent.svg"
  //       alt="AI智能体"
  //       style={{ width: '18px', height: '18px' }}
  //     />
  //   ),
  //   label: 'AI智能体',
  // },
]
